import type { VanillaLinkProps } from '../Link/index.ts';
import clsx from 'clsx';
import { PiCaretRightBold } from 'react-icons/pi';

interface BreadcrumbItem {
  key: string;
  label: React.ReactNode;
  renderLink?: (props: VanillaLinkProps) => React.ReactNode;
}

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center gap-x-3">
        {items.map((item, index) => {
          const link =
            item.renderLink && index < items.length - 1
              ? item.renderLink?.({
                  children: item.label,
                  className: clsx('font-medium text-gray-500 hover:text-gray-700'),
                  plain: true
                })
              : undefined;

          return (
            <li key={item.key}>
              <div className="flex items-center gap-x-3">
                {index > 0 && (
                  <PiCaretRightBold
                    className="size-3.5 shrink-0 text-gray-400"
                    aria-hidden="true"
                  />
                )}

                {link ? link : <span className="font-medium text-gray-500">{item.label}</span>}
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
